import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon_top",
  "use": "icon-icon_top-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" fill=\"currentColor\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-icon_top\">\n<g clip-path=\"url(#icon-icon_top_clip0_32952_24811)\">\n<path d=\"M3.42773 2.56641H21.4277V4.60582H3.42773V2.56641ZM13.7611 12.0836V22.2807H11.7611V12.0836H8.76107L12.7611 8.00483L16.7611 12.0836H13.7611Z\" fill=\"currentColor\" />\n</g>\n<defs>\n<clipPath id=\"icon-icon_top_clip0_32952_24811\">\n<rect width=\"24\" height=\"24\" fill=\"white\" />\n</clipPath>\n</defs>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol